import React, { useState } from 'react';
import { Phone, Mail, MapPin, ChevronRight } from 'lucide-react';
import Logo from './Logo';
import PrivacyPolicy from './PrivacyPolicy';
import CookiePolicy from './CookiePolicy';

const Footer: React.FC = () => {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isCookieOpen, setIsCookieOpen] = useState(false);

  return (
    <footer className="bg-primary-950 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <Logo color="light" darkMode={false} />
            <p className="mt-4 text-primary-200 text-sm">
              Transforming commercial properties into high-quality residential units since 2024. We specialise in converting underutilised spaces into modern, sustainable homes.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-primary-200 hover:text-white transition-colors flex items-center">
                  <ChevronRight size={14} className="mr-1" />
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-primary-200 hover:text-white transition-colors flex items-center">
                  <ChevronRight size={14} className="mr-1" />
                  About
                </a>
              </li>
              <li>
                <a href="/partners" className="text-primary-200 hover:text-white transition-colors flex items-center">
                  <ChevronRight size={14} className="mr-1" />
                  Partners
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-3">
              <a href="#" className="h-9 w-9 rounded-full bg-primary-800 flex items-center justify-center hover:bg-primary-700 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="#" className="h-9 w-9 rounded-full bg-primary-800 flex items-center justify-center hover:bg-primary-700 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a href="#" className="h-9 w-9 rounded-full bg-primary-800 flex items-center justify-center hover:bg-primary-700 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                  <rect x="2" y="9" width="4" height="12"></rect>
                  <circle cx="4" cy="4" r="2"></circle>
                </svg>
              </a>
            </div>
            <div className="mt-6 space-y-3">
              <a 
                href="tel:+448085310127" 
                className="flex items-center text-primary-200 hover:text-white transition-colors"
              >
                <Phone size={16} className="mr-2" />
                <span>+44 808 531 0127</span>
              </a>
              <a 
                href="mailto:office@slrooms.com" 
                className="flex items-center text-primary-200 hover:text-white transition-colors"
              >
                <Mail size={16} className="mr-2" />
                <span>office@slrooms.com</span>
              </a>
              <div className="flex items-start text-primary-200">
                <MapPin size={16} className="mr-2 mt-1 flex-shrink-0" />
                <span>1 London Road, Ipswich, Suffolk, IP1 2HA, United Kingdom</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-primary-300 text-sm">
              © {new Date().getFullYear()} SL Rooms. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <ul className="flex space-x-6 text-sm text-primary-300">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsPrivacyOpen(true);
                    }}
                    className="hover:text-white transition-colors"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsCookieOpen(true);
                    }}
                    className="hover:text-white transition-colors"
                  >
                    Cookie Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <PrivacyPolicy isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
      <CookiePolicy isOpen={isCookieOpen} onClose={() => setIsCookieOpen(false)} />
    </footer>
  );
};

export default Footer;